// hooks for the store configuration
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

// reducers (imported from slices)
import userReducer from "./slices/UserSlice";
import policyReducer from "./slices/PolicySlice";
import policyDetailReduer from "./slices/PolicyDetailSlice";

const rootReducer = {
  userReducer: userReducer,
  policyReducer: policyReducer,
  policyDetailReducer: policyDetailReduer,
};

export const store = configureStore({
  reducer: rootReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
